// extracted by mini-css-extract-plugin
export default {"AnswerWords":"transfer_AnswerWords__GmTvy","answerFields":"transfer_answerFields__QWB+q","container":"transfer_container__Y-SrX","text":"transfer_text__4wimB"};